export enum PartnerUserStatus {
  Active = "active",
  Disabled = "disabled",
}
